import script from "./LoteSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./LoteSwiper.vue?vue&type=script&setup=true&lang=js"

import "./LoteSwiper.vue?vue&type=style&index=0&id=c7f7d026&lang=css"

const __exports__ = script;

export default __exports__